import React from "react";

import { ListPage, ListPageContent } from "@src/features/app/ListPage";
import MyTrainingAssignmentsTable from "@src/features/myTraining/MyTrainingAssignmentsTable";
import MyCompletedTrainingTable from "@src/features/myTraining/MyCompletedTrainingTable";
import { QueryTabs } from "@src/lib/ui/QueryTabs";
import { usePortalTarget } from "@src/lib/hooks/usePortalTarget";
import MyTrainingFoodHandlerExams from "@src/features/myTraining/MyTrainingFoodHandlerExams";

const MyTrainingListPage: React.FC = () => {
  const subheaderPortal = usePortalTarget("top-nav-subheader");
  const filterBarContainer = usePortalTarget("top-nav-tertiary");

  return (
    <ListPage
      flushHorizontalPadding
      scrollInnerPadding="0 0 16px"
      scrollInnerGap={0}
    >
      <ListPageContent>
        <QueryTabs
          tabs={["assignments", "completed"]}
          defaultTab="assignments"
          labels={{
            assignments: "Assignments",
            completed: "Completed",
          }}
          render={{
            assignments: (
              <>
                <MyTrainingFoodHandlerExams />
                <MyTrainingAssignmentsTable
                  filterBarContainer={filterBarContainer}
                />
              </>
            ),
            completed: (
              <MyCompletedTrainingTable
                filterBarContainer={filterBarContainer}
              />
            ),
          }}
          subheaderPortal={subheaderPortal}
          removeVerticalPadding={{
            assignments: true,
            completed: true,
          }}
        />
      </ListPageContent>
    </ListPage>
  );
};

export default MyTrainingListPage;
